export const deClientPortalValuationTenantListPage = {
    rowsLabel_one: '{{count}} Zeile',
    rowsLabel_other: '{{count}} Zeilen',
    viewSwitch: {
        summary: 'Zusammenfassung',
        tenantDetails: 'Mieterdetails',
    },
    tenantDetailsTable: {
        discrepancyTooltip: {
            title: 'Abweichung der Summen',
            description: 'Die Summe der Mieterdetails stimmt nicht mit der Angabe unter Zusammenfassung überein. Bitte überprüfen.',
            details: 'Mieterdetails',
            summary: 'Zusammenfassung',
            discrepancy: 'Abweichung',
        },
        discrepancyTooltipTitle: 'Spalten mit Abweichungen:',
        discrepancyHeaders: {
            units: 'EH/STPL',
            area: 'Fläche',
            contractRentPerYear: 'Vertragsmiete P.A.',
            marketRentPerYear: 'Marktübl. Miete P.A.',
        },
        headers: {
            id: 'ID',
            floor: 'Etage',
            tenant: 'Mieter',
            subUsageType: 'Unternutzungsart',
            leaseId: 'Mietvertrag-ID',
            status: 'Status',
            area: 'Fläche',
            units: 'EH/STPL',
            startDate: 'Startdatum',
            endDate: 'Enddatum',
            remainingLeaseTerm: 'RLZ',
            contractRentPerMonth: 'Vertragsmiete P.M.',
            contractRentPerYear: 'Vertragsmiete P.A.',
            marketRentPerMonth: 'Marktübl. Miete P.M.',
            marketRentPerYear: 'Marktübl. Miete P.A.',
            absoluteDelta: 'Delta absolut',
            deltaPercentage: 'Delta %',
            comments: 'Kommentare',
        },
        labels: {
            area: 'Fläche',
            vacancyArea: 'Leerstandsfläche',
            units: 'EH/Stpl.',
            vacancyUnits: 'Leerstand EH/Stpl.',
            indefinite: 'unbef.',
            years: 'Jahre',
        },
        unitLabels: {
            regular: 'EH',
            parking: 'Stpl.',
            perYear: '/Jahr',
            perSquareMeter: '/m²',
            perUnit: '/EH',
            perParkingSpace: '/Stpl.',
        },
    },
    summary: {
        marketRentPerYear: 'Marktübl. Miete p.a.',
        delta: 'Δ Delta',
        contractRentPerYear: 'Vertragsmiete p.a.',
        rented: 'Vermietet',
        vacant: 'Leerstehend',
        totalUsableArea: 'Nutzfläche gesamt',
        parkingSpaces: '{{count}} Stpl.',
        totalParkingSpaces: 'Stellplätze gesamt',
    },
}
